import { RoleGuard } from '../../routes';
import { DashboardFormWrapper } from '../dashboard';
import { InventoryPage } from './InventoryComponents';
import { InventoryAddHeader, InventoryAddForm } from './InventoryAddComponents';

export const InventoryAdd = () => {
  return (
    <RoleGuard roles={['SUPER_ADMIN', 'YARD_COMPANY_ADMIN', 'YARD_MANAGER']}>
      <InventoryPage>
        <InventoryAddHeader />
        <DashboardFormWrapper flow={'row'}>
          <InventoryAddForm />
          <InventoryAddHeader showOnlySubmit />
        </DashboardFormWrapper>
      </InventoryPage>
    </RoleGuard>
  );
};
